const OSS_HOST = 'https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com';

function safeName(name) {
    return (name || '未命名作品')
        .replace(/[\\/:*?"<>|]+/g, '-')
        .replace(/\s+/g, ' ')
        .trim() || '未命名作品';
}

function assetUrl(path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    return `${OSS_HOST}/${String(path).replace(/^\/+/, '')}`;
}

function downloadBlob(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.setTimeout(() => URL.revokeObjectURL(url), 0);
}

function loadImage(path) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error('作品图片加载失败'));
        image.src = assetUrl(path);
    });
}

export async function exportFourKImage(path, name) {
    const image = await loadImage(path);
    const canvas = document.createElement('canvas');
    canvas.width = 3840;
    canvas.height = 2160;
    const context = canvas.getContext('2d');
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);

    const scale = Math.min(canvas.width / image.naturalWidth, canvas.height / image.naturalHeight);
    const width = image.naturalWidth * scale;
    const height = image.naturalHeight * scale;
    context.drawImage(image, (canvas.width - width) / 2, (canvas.height - height) / 2, width, height);

    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    if (!blob) throw new Error('高清图生成失败');
    downloadBlob(blob, `${safeName(name)}-4K.png`);
}

export function exportImagePdf(path, name) {
    const url = assetUrl(path);
    const preview = window.open('', '_blank');
    if (!preview) throw new Error('浏览器阻止了 PDF 导出窗口');
    const title = safeName(name);
    preview.document.write(`<!doctype html><html><head><title>${title}</title><style>
        @page { size: landscape; margin: 0; }
        html, body { width: 100%; height: 100%; margin: 0; background: #fff; }
        body { display: flex; align-items: center; justify-content: center; }
        img { display: block; max-width: 100%; max-height: 100%; object-fit: contain; }
    </style></head><body><img src="${url}" alt="${title}"></body></html>`);
    preview.document.close();
    const image = preview.document.querySelector('img');
    image.onload = () => {
        preview.focus();
        preview.print();
    };
    image.onerror = () => preview.close();
}

function readMaterialRows(work) {
    const materials = Array.isArray(work.useMaterials) ? work.useMaterials : [];
    return materials.map(item => ({
        name: item.materialName || item.name || '未命名素材',
        count: item.count || item.quantity || 1,
        specification: item.specification || item.spec || item.size || '无',
        price: item.price == null || item.price === '' ? '无' : item.price,
    }));
}

function escapeCell(value) {
    return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

export function exportMaterialsExcel(work) {
    const rows = readMaterialRows(work);
    const body = rows.length
        ? rows.map(item => `<tr><td>${escapeCell(item.name)}</td><td>${escapeCell(item.count)}</td><td>${escapeCell(item.specification)}</td><td>${escapeCell(item.price)}</td></tr>`).join('')
        : '<tr><td colspan="4">暂无可识别素材</td></tr>';
    const html = `<!doctype html><html><head><meta charset="utf-8"></head><body><table border="1"><thead><tr><th>素材名称</th><th>数量</th><th>规格</th><th>价格</th></tr></thead><tbody>${body}</tbody></table></body></html>`;
    downloadBlob(
        new Blob(['\ufeff', html], { type: 'application/vnd.ms-excel;charset=utf-8' }),
        `${safeName(work.name)}-素材清单.xls`
    );
    return rows.length;
}

export { assetUrl };
